import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Container } from "react-bootstrap";

export default class CustomNavbar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			workExperience: "Work Experience",
		};
	}

	componentDidMount = () => {
		this.screenCheck();

		// Listen to scroll event for sticky navbar
		window.onscroll = this.stickyNavbar();

		window.addEventListener("resize", this.screenCheck.bind(this));
	};

	// If page width is less than 368px, change 'Work Experience' with 'Work Exp.' so that responsiveness is preserved
	screenCheck = () => {
		const condition =
			window.innerWidth <= 368 ||
			document.documentElement.clientWidth <= 368 ||
			document.body.clientWidth <= 368;
		condition
			? this.setState({
					workExperience: "Work Exp.",
			  })
			: this.setState({
					workExperience: "Work Experience",
			  });
	};

	stickyNavbar = () => {
		const navbar = document.getElementById("nav-main");
		const sticky = navbar.offsetTop;
		const navbarClassList = navbar.classList;
		navbarClassList[window.pageYOffset >= sticky ? "add" : "remove"](
			"sticky"
		);
	};

	render() {
		const { workExperience } = this.state;
		const listItems = [
			{
				id: "#contact",
				label: "Contact",
			},
			{
				id: "#projects",
				label: "Projects",
			},
			{
				id: "#work-experience",
				label: workExperience,
			},
		];
		return (
			<ul className="nav-ul list-group" id="nav-main">
				<Container>
					<li className="nav-li">
						<a href="#">
							<FontAwesomeIcon icon={faHome} />
						</a>
					</li>
					{listItems.map((listItem) => (
						<li key={listItem.id} className="nav-li float-right">
							<a href={listItem.id}>{listItem.label}</a>
						</li>
					))}
				</Container>
			</ul>
		);
	}
}
